<div class="page-content">
    <div class="page-header">
        <h1>Project</h1>
        <div class="page-description">Créer un nouveau projet</div>
    </div>

    <div class="page-body">
            <div class="modal-content-body" [formGroup]="projectFormGroup">
                <div class="form-row">
                    
                    <div class="half-width">
                        <label for="email" class="required">Code</label>
                        <ed-textfield
                            innerId="code"
                            name="code"
                            type="code"
                            placeholder="2026001"
                            [required]="true"
                            [formControlName]="'code'"></ed-textfield>
                    </div>
                </div>
                <div class="form-row">
                    <div class="half-width">
                        <label for="firstname" class="required">Label</label>
                        <ed-textfield
                            innerId="Label"
                            name="Label"
                            type="text"
                            placeholder="Client - Mission"
                            [required]="true"
                            [formControlName]="'label'"></ed-textfield>
                    </div>
                </div>
                <div class="form-row">
                    <div class="half-width">
                        <label for="soldAmount" class="required">Montant total</label>
                        <ed-numberfield
                            innerId="soldAmount"
                            name="soldAmount"
                            type="number"
                            unit="€ HT"
                            placeholder="100 000"
                            [required]="true"
                            [formControlName]="'soldAmount'"></ed-numberfield>
                    </div>
                    <div class="half-width">
                        <label for="subcontractingAmount">Montant sous-traitance</label>
                        <ed-numberfield
                            innerId="subcontractingAmount"
                            name="subcontractingAmount"
                            unit="€ HT"
                            type="number"
                            placeholder="0"
                            [formControlName]="'subcontractingAmount'"></ed-numberfield>
                    </div>
                    <div class="half-width">
                        <label for="soldDayRate" >Tarif journalier</label>
                        <ed-numberfield
                            innerId="soldDayRate"
                            name="soldDayRate"
                            type="number"
                            unit="€ HT/jours"
                            placeholder="850"
                            [required]="false"
                            [formControlName]="'soldDayRate'"></ed-numberfield>
                    </div>
                </div>
                <div class="form-row">  
                    <div class="half-width">
                        <label for="activityId" class="required">Activité</label>
                        <ed-select
                        id="activityId"
                        placeholder="Activité"
                        [formControlName]="'activityId'"
                        [required]="true"
                        [options]="activityList">
                        </ed-select>  
                    </div>
                     <div class="half-width">
                        <label for="estimatedCloseDate">Date de cloture estimée</label>
                        <ed-datepicker
                        id="estimatedCloseDate"
                        [required]="false"
                        [formControlName]="'estimatedCloseDate'"
                        >
                        </ed-datepicker>  
                    </div>
                </div>
                
                <div class="form-row">  
                   
                    <div class="half-width">
                        <label for="leadUserId" class="required">Chef.fe de projet</label>
                        <ed-search
                        id="leadUserId"
                        placeholder="Séléctionnez un chef de projet"
                        [formControlName]="'leadUserId'"
                        [isMulti]="false"
                        [required]="false"
                        [options]="leadUserList">
                        </ed-search>  
                    </div>
                </div>
            </div>

            <div class="layer-actions">
                <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
                <ed-button (click)="valid()" [disabled]="canCreateEdit()">Ajouter le projet</ed-button>
            </div>
    </div>
</div>